import { IRequestConfig, MethodsTypes } from 'models/Axios';
import axios from 'axios';
import buildQuery from 'odata-query';
import { ICustomer } from 'models/Customer';
import Services from './index.service';

export default class CustomerService extends Services<any, any> {
  public async autoComplete(str: any, legalPerson: string = '') {

    str = str.replaceAll('.', '')
             .replaceAll('/', '')
             .replaceAll('-', '')

    const config: IRequestConfig<any> = {
      url: `${this.base_url}/customer/autocomplete?sentence=${str}&legalPersonType=${legalPerson}`,
      method: MethodsTypes.get,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
    };

    return await axios(config)
      .then((result) => result.data)
      .catch(() => []);
  }

  public get = (
    currentPage?: number,
    pageSize?: number,
    orderby?: string,
    filter?: {}
  ) => {
    const skip = currentPage || 0;
    const top = pageSize || 20;
    const order = orderby ? `${orderby}` : undefined;
    const filterQuery = buildQuery({ filter });

    const config: IRequestConfig<ICustomer> = {
      url: `/customer`,
      params: {
        $top: `${top}`,
        $skip: `${skip * top}`,
        $orderby: order,
        $filter: filterQuery.split('=')[1] || undefined,
      },
    };

    return this.httpRequest(config);
  };

  public findById = (id: string) => {
    const config: IRequestConfig<ICustomer> = {
      url: `/customer/${id}`,
    };

    return this.httpRequest(config);
  };

  create = (data: any) => {
    const config: IRequestConfig<ICustomer> = {
      url: `${this.base_url}/customer`,
      method: MethodsTypes.post,
      data,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },
    };

    return axios(config);
  };

  update = (id: any) => {
    const config: IRequestConfig<ICustomer> = {
      url: `/customer/import-from-protheus?customerId=${id}`,
      method: MethodsTypes.get
    };

    return this.httpRequest(config);
  };
}
